import { push } from 'connected-react-router';
import { put, takeLatest, call, select } from 'redux-saga/effects';

import { navigateWizard } from '../actions';
import { SIGN_IN } from '../constants/actionTypes';
import { LOG_IN_SUCCESS } from '../constants/heapEvents';
import { userEvent, addUserProperties } from '../lib/heapHelpers';
import { isEmptyObject } from '../lib/helpers';
import { orientation, dimensions } from '../lib/viewportInfo';
import { currentPathSelector } from '../reducers/selectors';

function* userWatcher() {
  yield takeLatest(SIGN_IN, userWorker);
}

function* userWorker(action) {
  const { user } = action;
  const { profile } = user;
  const isAuthenticated = !isEmptyObject(profile);

  if (isAuthenticated) {
    const currentPath = yield select(currentPathSelector);

    yield call(userEvent, profile.sub, LOG_IN_SUCCESS, {});
    yield call(addUserProperties, {
      'Initial viewport dimensions': dimensions(),
      'Initial orientation': orientation(),
    });

    if (
      !currentPath.startsWith('/continue/') &&
      !currentPath.startsWith('/provisional-offer/') &&
      currentPath !== '/reload'
    ) {
      yield put(navigateWizard({ dir: 'fwd' }));
    }
  } else {
    yield put(push('/reload'));
  }
}

export { userWorker };
export default userWatcher;
